/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import ScenarioSelectorCard from "./ScenarioSelectorCard";
import ScenariosDropdownSummary from "../scenarios-dropdown/ScenariosDropdownSummary";

const myStyles = makeStyles((theme) => ({
  scenarioSelectorContainer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fafafa",
    border: "1px #E0E0E0 solid",
    borderRadius: "5px",
    padding: "10px 7px 10px 7px",
    boxSizing: "border-box",
    overflowY: "auto",
    fontSize: "inherit",
    fontFamily: "inherit",
    [theme.breakpoints.up(2560)]: { width: "17%" },
    [theme.breakpoints.between(1920, 2560)]: { width: "19%" },
    [theme.breakpoints.between(1440, 1920)]: { width: "21%" },
    [theme.breakpoints.between(1280, 1440)]: { width: "22.5%" },
    [theme.breakpoints.down(1280)]: { width: "100%", height: "auto" },
  },
  selectedScenariosContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    fontSize: "inherit",
    fontFamily: "inherit",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      flexDirection: "row",
      height: "130px",
      padding: "10px 0 10px 0",
    }, // > 960px
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "700px",
      alignItems: "stretch",
    }, // < 960px
  },
}));

const ScenariosList = () => {
  const classes = myStyles();
  const { selectedScenarios } = useSelector((state) => state.summary);
  const { totalsByScenarioId } = useSelector((state) => state.scenarios);
  const selectedScenariosWithData = selectedScenarios
    .map((scenarioId) => totalsByScenarioId[scenarioId])
    .slice(0, 5);
  const scenarioSlots = Array(5).fill(null);
  selectedScenariosWithData.forEach((scenario, index) => {
    scenarioSlots[index] = scenario;
  });

  return (
    <div className={classes.scenarioSelectorContainer}>
      <ScenariosDropdownSummary />
      <div className={classes.selectedScenariosContainer}>
        {scenarioSlots.map((scenarioData, index) => (
          <ScenarioSelectorCard
            key={`${scenarioData?.scenario_id} + ${index}`}
            scenarioId={scenarioData?.scenario_id}
            scenarioName={scenarioData?.scenario?.name}
            sellOut={scenarioData?.units}
            margin={scenarioData?.margin}
            salesOut={scenarioData?.sales}
            priceOut={scenarioData?.weighted_avg_price_units}
            retailerMargin=""
          />
        ))}
      </div>
    </div>
  );
};

export default ScenariosList;
